// exposed here for testing/mocking purposes
// will not work with Internet Explorer
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions
export const getResolvedDateTimeFormatOptions = () => {
  return Intl.DateTimeFormat().resolvedOptions();
};
